import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Store } from "lucide-react";

// QR landing page. IMPORTANT — no backend shop/company/table-identifier
// system exists anywhere in FastAPI (confirmed by inspecting every
// router): there is no GET /shops/{id}, no "public menu by identifier"
// endpoint, nothing to validate a scanned code against. So this page
// cannot do what a `/menu/:identifier` route implies (look up a shop,
// detect "inactive shop", etc.) without inventing an API — which this
// build deliberately does not do.
//
// What IS real: this app has exactly one public menu — the Shop page,
// backed by the real GET /products. A QR code should simply encode this
// URL directly (http://localhost:8001/menu or /shop) rather than a
// per-shop identifier the backend has no way to resolve.
export default function Menu() {
  const navigate = useNavigate();

  useEffect(() => {
    const t = setTimeout(() => navigate("/shop", { replace: true }), 900);
    return () => clearTimeout(t);
  }, [navigate]);

  return (
    <div className="max-w-sm mx-auto px-4 py-24 text-center">
      <Store size={32} className="mx-auto text-neutral-700 mb-4" />
      <h1 className="text-lg font-semibold text-neutral-900">Opening menu...</h1>
      <p className="mt-2 text-sm text-neutral-500">
        Redirecting you to the shop.
      </p>
    </div>
  );
}
